import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Header, HeaderLabel, HeaderIcon, Brand, Body, Store, StoreCode, Details, Name, Interactions } from './TopStores.style'
import { BlueBox, NoResults } from '../common'
import { Padding } from '../../../..'
import { NumberUtils } from '../../../../../utils'

const WorstStores = ({ isEmpty, loading, onClickHeader, stores, t }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Padding fullHeight>
            <Header>
                <HeaderLabel onClick={onClickHeader}>
                    {t('Worst 5 Stores')}
                    <HeaderIcon icon="random" />
                </HeaderLabel>
                <Brand />
            </Header>
            <Body>
                {isEmpty && <NoResults />}
                {!isEmpty &&
                    stores.map(({ store, store_code, interactions }, index) => {
                        const displayInteractions = NumberUtils.withDecimalsIfNeeded(interactions)

                        return (
                            <Store key={store_code}>
                                <Details>
                                    <Name>
                                        {index + 1}
                                        &#46;&nbsp;&nbsp;&nbsp;
                                        <StoreCode>{store_code}</StoreCode>
                                        &nbsp;
                                        {store && store.name}
                                    </Name>
                                </Details>
                                <Interactions>{`${displayInteractions} interactions`}</Interactions>
                            </Store>
                        )
                    })}
            </Body>
        </Padding>
    </BlueBox>
)

WorstStores.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    onClickHeader: PropTypes.func,
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            store_code: PropTypes.string,
            unique_visitors: PropTypes.number,
            deviceCount: PropTypes.number,
            rating: PropTypes.string,
        })
    ),
    t: PropTypes.func.isRequired,
}

WorstStores.defaultProps = {
    isEmpty: true,
    loading: null,
    onClickHeader: () => null,
    stores: [],
}

export default withTranslation()(WorstStores)
